<template>
  <v-card class="mb-2">
    <v-card-title class="pb-1">
      <v-layout v-if="client.companies.length === 1" align-center>
        <div
          class="font-weight-bold"
          @click="
            changeCurrentCompany(
              $event,
              client.companies[0].id,
              `/admin-dashboard?companyId=${client.companies[0].id}`,
            )
          "
        >
          {{
            isIndividual(client.companies[0])
              ? client.companies[0].tax_return_name
              : `${client.companies[0].name} (${client.full_name})`
          }}
        </div>
        <v-tooltip
          bottom
          v-if="hasNewMessage(client.id) && client.id !== currentUser.id"
        >
          <v-icon
            slot="activator"
            color="success"
            @click="
              changeCurrentCompany(
                $event,
                client.companies[0].id,
                `/conversation?companyId=${client.companies[0]}`,
              )
            "
            >mail</v-icon
          >
          <span>New Message</span>
        </v-tooltip>
      </v-layout>
      <v-menu
        transition="slide-y-transition"
        bottom
        nudge-bottom="30"
        class="my-1"
        v-else
      >
        <v-layout slot="activator" align-center>
          <span class="font-weight-bold">{{ client.tax_return_name }}</span
          ><v-chip small round class="ml-2"
            >{{ client.companies.length }} Entities</v-chip
          >
          <v-tooltip
            bottom
            v-if="hasNewMessage(client.id) && client.id !== currentUser.id"
          >
            <v-icon
              slot="activator"
              color="success"
              v-if="hasNewMessage(client.id) && client.id !== currentUser.id"
              >mail</v-icon
            >
            <span>New Message</span>
          </v-tooltip>
        </v-layout>
        <v-list>
          <v-list-tile
            :key="i"
            v-for="(company, i) in client.companies"
            @click="
              changeCurrentCompany(
                $event,
                company.id,
                `/admin-dashboard?companyId=${company.id}`,
              )
            "
          >
            <v-list-tile-title>
              {{ company.name }} ({{ company.entity_type }})
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-card-title>
    <v-card-text class="text-xs-left p-0">
      {{ client.email }} <br />
      <label class="font-weight-bold">Phone: </label
      >{{
        client.phone_number ? `/ ${maskPhoneNumber(client.phone_number)}` : '-'
      }}
      <br />
    </v-card-text>
    <v-card-actions>
      <v-menu
        transition="slide-y-transition"
        bottom
        right
        nudge-bottom="30"
        class="my-1"
      >
        <v-btn flat slot="activator"> Actions </v-btn>
        <slot name="actions" v-bind:client="client" />
      </v-menu>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import UtilsMixins from '@/mixins/UtilsMixins';

export default {
  name: 'ClientCard',
  mixins: [UtilsMixins],
  props: {
    client: {
      type: Object,
    },
    changeCurrentCompany: {
      type: Function,
    },
    isIndividual: {
      type: Function,
    },
    hasNewMessage: {
      type: Function,
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'user',
    }),
  },
  methods: {},
};
</script>

<style scoped></style>
